import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { getFreeTrialExams } from 'services/ExamsService'
import { Exam } from 'types/exams'
import { FreeTrialFeaturedExamTile } from './FreeTrialFeaturedExamTile'

export const FreeTrialFeaturedExamsWidget = () => {
  const [examsList, setExamsList] = useState<Exam[]>([])

  const fetchFreeTrialExams = () => {
    const handleSuccess = response => {
      setExamsList(
        [...response.data]
          .sort((a, b) => a.title.localeCompare(b.title))
          .filter(exam => exam.free_trial_featured_exam)
      )
    }
    const handleError = error => {
      console.error(error)
    }

    getFreeTrialExams().then(handleSuccess).catch(handleError)
  }

  useEffect(() => {
    fetchFreeTrialExams()
  }, [])

  const renderExams = () => {
    return examsList.map(exam => (
      <FreeTrialFeaturedExamTile
        key={`free-trial-featured-exam-${exam.id}`}
        exam={exam}
      />
    ))
  }

  return examsList.length > 0 ? <Container>{renderExams()}</Container> : null
}

const Container = styled.div`
  z-index: 1;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`
